// extracted by mini-css-extract-plugin
module.exports = {"slider-label":"style_slider-label__eYA_u"};